import { render, staticRenderFns } from "./gymlist.vue?vue&type=template&id=77e05c68&scoped=true"
import script from "./gymlist.vue?vue&type=script&lang=js"
export * from "./gymlist.vue?vue&type=script&lang=js"
import style0 from "./gymlist.vue?vue&type=style&index=0&id=77e05c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e05c68",
  null
  
)

export default component.exports